module.exports = __webpack_public_path__ + "img/contentIcon.945831d8.png";